/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import { FileType } from "Api";

// Maintain a list of file types the Dexter parser currently supports.
// This can be used throughout the application wherever needed.
// Use it by seeing if the type of interest is a member of this list.
// Update as the parser's capabilities are extended.
export const SUPPORTED_FILE_TYPES: FileType[] = [
  FileType.XML,
  FileType.PROTO,
  FileType.PB2,
];
